import { render, staticRenderFns } from "./Moscow.vue?vue&type=template&id=b88878a2&scoped=true&"
import script from "./Moscow.vue?vue&type=script&lang=js&"
export * from "./Moscow.vue?vue&type=script&lang=js&"
import style0 from "./Moscow.vue?vue&type=style&index=0&id=b88878a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88878a2",
  null
  
)

export default component.exports